<template>
  <div class="vehicle-search container">
    <div class="tabs row">
      <div v-for="tab in tabs" :key="tab.name" @click="selectedTab = tab.name" :class="{ 'active': selectedTab === tab.name, 'col': true }" class="tab">
        <i :class="tab.icon"></i>
        <span>{{ tab.name }}</span>
      </div>
    </div>
    <div class="search-fields">
      <!-- Grupowanie pierwszego rzędu pól -->
      <div class="fields-row col-md-6">
        <select class="form-control" v-model="searchParams.brand">
          <option disabled value="">Marka pojazdu</option>
          <!-- Opcje marki pojazdu -->
        </select>
        <select class="form-control" v-model="searchParams.model">
          <option disabled value="">Model pojazdu</option>
          <!-- Opcje modelu pojazdu -->
        </select>
      </div>
      <!-- Grupowanie drugiego rzędu pól -->
      <div class="fields-row col-md-6">
        <input type="number" class="form-control" placeholder="Cena do" v-model="searchParams.price">
        <input type="number" class="form-control" placeholder="Rok od" v-model="searchParams.year">
      </div>
      <!-- Grupowanie trzeciego rzędu pól -->
      <div class="fields-row col-md-6">
        <select class="form-control" v-model="searchParams.fuelType">
          <option disabled value="">Rodzaj paliwa</option>
          <!-- Opcje rodzaju paliwa -->
        </select>
      </div>
      <button class="btn btn-primary" @click="submitSearch">Szukaj</button>
    </div>
  </div>
</template>

  
  <script>
  export default {
    name: 'VehicleSearch',
    data() {
      return {
        selectedTab: 'Osobowe',
        tabs: [
          { name: 'Osobowe', icon: 'fas fa-car' },
          { name: 'Ciężarowe', icon: 'fas fa-truck-moving' },
          { name: 'Dostawcze', icon: 'fas fa-truck' },
          { name: 'Motocykle', icon: 'fas fa-motorcycle' }
        ],
        searchParams: {
          brand: '',
          model: '',
          price: null,
          year: null,
          bodyType: '',
          fuelType: ''
        }
      };
    },
    methods: {
      submitSearch() {
        // Logika wysyłania zapytania do serwera
        console.log('Search parameters:', this.searchParams);
      }
    }
  }
  </script>
  
  <style scoped>
.vehicle-search {
  background: #ffffff; /* Białe tło dla lepszej widoczności */
  /* padding: 20px; Dodanie paddingu dla estetyki */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); Lekki cień dla wyróżnienia */
  border-radius: 8px; /* Zaokrąglone rogi */
}

.tabs {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px; /* Odstęp między zakładkami a formularzem */
}
@media (max-width: 768px) {
  .tabs {
    display: none; /* Ukryj zakładki na urządzeniach mobilnych */
  }
}

.tab {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.tab.active {
  border-bottom: 2px solid #d9230f; /* Czerwone podkreślenie dla aktywnej zakładki */
}

.search-fields {
  padding: 15px;
  background: #fff; /* Białe tło dla pól formularza */
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  border-radius: 5px;
}

.search-fields select, .search-fields input {
  flex: 1;
  margin-right: 10px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  /* width: 250px;  */
}

.search-fields button {
  padding: 10px 20px;
  background-color: #d9230f; /* Czerwony kolor przycisku */
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

/* Usunięcie marginesu z ostatniego elementu w kontenerze */
.search-fields select:last-child, .search-fields input:last-child {
  margin-right: 0;
}


button {
  padding: 10px 20px;
  background-color: #d9230f; /* Czerwony kolor przycisku */
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px; /* Zaokrąglone rogi dla przycisku */
}
@media (max-width: 768px) {
  .search-fields, .tabs {
    flex-direction: column;
  }

  .search-fields select, .search-fields input, .search-fields button {
    margin: 10px 0; /* Więcej miejsca między polami na małych ekranach */
  }
}
.fields-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

</style>